export default {
  heroTitle: '6080新视觉影视',
  heroSubtitle: '免费高清电影在线观看，不缓冲流畅播放',
  heroDesc: '海量电影大全覆盖最新大片、经典佳作，每日更新，高清画质无需VIP',
  heroSearch: '输入电影名称搜索...',
  heroCTA: '立即观影',
  latestMovies: '最新更新',
  hotMovies: '热门推荐',
  viewAll: '查看全部',
  categoryTitle: '分类浏览',
  siteFeatures: '平台特色',
  feature1Title: '海量资源',
  feature1Desc: '收录数万部电影资源，每日更新',
  feature2Title: '高清画质',
  feature2Desc: '支持4K超清画质，视觉享受',
  feature3Title: '流畅播放',
  feature3Desc: '高速服务器，不缓冲不卡顿',
  feature4Title: '免费观看',
  feature4Desc: '无需VIP会员，完全免费观影',
};